<mat-slide-toggle [(ngModel)]="checked" aria-label="label"[disabled]="disabled" [color]="color" [checked]="checked" (change)="onChange($event)">
    <ng-content></ng-content>
</mat-slide-toggle>